import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';

export class VisitorRegistrationTypeSelectionController extends AbstractStepController {

  private dialogService: DialogService;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === TerminalContextConstants.registerTransportManually) {
      this.onRegisterTransportManually();
    } else if (contextChange.key === TerminalContextConstants.registerTransportWithCode) {
      this.onRegisterTransportWithCode();
    } else if (contextChange.key === TerminalContextConstants.registerTransportWithQRCode) {
      this.onRegisterTransportWithQRCode();
    }
  }

  onRegisterToDashboardContext() {

  }

  private onRegisterTransportManually() {
    this.wizardComponent.stopInactivityMonitoring();
    this.wizardComponent.next('visitor-registration-masterdata');
  }

  private onRegisterTransportWithCode() {
    this.wizardComponent.stopInactivityMonitoring();
    this.wizardComponent.next('visitor-registration-with-code');
  }

  private onRegisterTransportWithQRCode() {
    this.wizardComponent.stopInactivityMonitoring();
    this.wizardComponent.next('visitor-registration-with-qrcode');
  }

  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('registration type selection for visitor started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      }
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }
}
